import { useSelector } from 'react-redux'
import { Loading } from '../../../common/loading'
import { Notification } from '../../../common/notification'

const withLoadingFeedback = (Component) => (props) => {
  const { isLoading, selectIds } = props
  const ids = useSelector(selectIds)

  if (isLoading) return <Loading />

  if (!ids.length) return <Notification />

  return <Component {...props} />
}

export default withLoadingFeedback
